import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import chat from '../../assets/icon/message.svg';
import location from '../../assets/icon/address.svg';
import quote from '../../assets/icon/quote.svg';
import edit from '../../assets/icon/edit.svg';
import Button from './button';

const Article = Styled.article`
border: solid 1px ${color.light};
background-color:${color.white};
display: grid;
grid-template-columns: ${(props) =>
  props.image ? 'max-content 1fr max-content' : 'max-content 1fr'};
padding: 2rem;
border-radius: 3px;
max-width: 50rem;
grid-gap: 2rem;
`;
const ArticleText = Styled.div`
color:${color.primary};
p{font-size:1.7rem; margin-bottom: 1rem; max-width: 25ch};
display: ${(props) => (props.image ? 'block' : 'flex')};
align-items: center;
justify-content: space-between;
`;

const ArticleIcon = Styled.figure`
height: 6rem;
width: 6rem;
display: block;
border-radius: 100rem;
background-color: ${color.secondaryAlt};
overflow:hidden;
img{width: 100%;height:100%;object-fit:cover}
`;

const ArticleAvatar = Styled.figure`
height: 12rem;
width: 12rem;
display: block;
border-radius: 3px;
background-color: ${color.primary};
overflow:hidden;
img{width: 100%;height:100%;object-fit:cover}
`;

const ServiceQuote = ({ text, image, address }) => {
  return (
    <Article selected={false} image={image}>
      <ArticleIcon>
        <img src={address ? location : quote} alt="" />
      </ArticleIcon>
      <ArticleText image={image}>
        <p>{text}</p>
        <Button
          type="light"
          text={address ? 'Edit' : 'Chat'}
          icon={address ? edit : chat}
        />
      </ArticleText>
      {image && (
        <ArticleAvatar>
          <img src={image} alt="" />
        </ArticleAvatar>
      )}
    </Article>
  );
};

export default ServiceQuote;
